import { FocusSelectorState } from '../focus-selector.state';
import { FocusSelectorDialogResult } from '../model/focus-selector-dialog-result.model';
import { FocusSelectorFocusForPerformer } from '../model/focus-selector-focus-for-performer.model';
import { FocusSelectorFocusModel } from '../model/focus-selector-focus.model';

export function getFocusSelectorResult(
    commitmentId: number,
    state: FocusSelectorState,
    observationSelectedFocus: FocusSelectorFocusModel = null,
): FocusSelectorDialogResult {
    const {
        selectedFocus: stateSelectedFocus,
        activeFocusesForPerformer,
        otherFocusesForPerformer,
        performerId,
    } = state;

    let matchedFocus: FocusSelectorFocusForPerformer;
    const selectedFocus =
        observationSelectedFocus != null
            ? observationSelectedFocus
            : stateSelectedFocus;
    const focuses = [...activeFocusesForPerformer, ...otherFocusesForPerformer];

    if (
        state.selectedFocus?.behaviour?.id != null &&
        state.selectedFocus?.subBehaviour?.id != null
    ) {
        matchedFocus = focuses.find(
            (focus) =>
                focus.behaviourId === selectedFocus?.behaviour?.id &&
                focus.tacticId === selectedFocus?.subBehaviour?.id,
        );
    }

    const { selectedMetricIds, selectedActiveMetricIds } =
        getSelectedFocusMetrics(state, observationSelectedFocus != null);

    return {
        selected: {
            focusId: matchedFocus?.focusId ?? (undefined as any),
            userId: performerId,
            behaviourId: selectedFocus?.behaviour?.id,
            subBehaviourId: selectedFocus?.subBehaviour?.id,
            metrics: [...selectedMetricIds, ...selectedActiveMetricIds],
        },
        commitmentId,
        activeCommitmentFocuses: null,
        activeFocusesForPerformer,
        selectedActiveMetricIds,
        commitmentKpis: state.goalsCollection.commitmentKpis,
    };
}

function getSelectedFocusMetrics(
    state: FocusSelectorState,
    includeActiveMetric: boolean = false,
): {
    selectedMetricIds: number[];
    selectedActiveMetricIds: number[];
} {
    const { activeMetric, selectedGoals, activeCommitmentGoalMetricIds } =
        state;

    const selectedMetricIds = [];
    const selectedActiveMetricIds = [];

    Object.keys(selectedGoals).forEach((keyAndMetricId) => {
        const metricId = parseInt(keyAndMetricId);
        if (selectedGoals[keyAndMetricId] != null) {
            if (activeCommitmentGoalMetricIds.includes(metricId)) {
                selectedActiveMetricIds.push(metricId);
            } else {
                selectedMetricIds.push(metricId);
            }
        }
    });

    if (includeActiveMetric) {
        if (activeCommitmentGoalMetricIds.includes(activeMetric.id)) {
            if (!selectedActiveMetricIds.includes(activeMetric.id)) {
                selectedActiveMetricIds.push(activeMetric.id);
            }
        } else {
            if (!selectedMetricIds.includes(activeMetric.id)) {
                selectedMetricIds.push(activeMetric.id);
            }
        }
    }

    return { selectedMetricIds, selectedActiveMetricIds };
}
